<template>
	<div class="toolbar-search-view">
		<input class="tool-text" :placeholder="placeholder" type="text" slot="tools" @input="onInput" :value="_value" @focus="onFocus" @blur="onBlur" />
		<div class="close" v-if="value !== null" @click="onClear">
			<svg-icon class="icon" icon="close" />
		</div>
		<div v-if="open" class="options">
			<div class="option" v-for="(option, i) in options" :key="i" @mousedown="onSelect(option)">{{ option.value }}</div>
			<div class="none" v-if="options.length == 0">Ingen valgmuligheder</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			placeholder: {
				type: String,
				default: 'Søg',
			},
			options: {
				type: Array,
				default: () => [],
			},
			value: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				open: false,
				focus: false,
				search: '',
			};
		},
		computed: {
			_value() {
				if (this.focus) return this.search;
				return this.value ? this.options.find(option => option.key == this.value).value : null;
			},
		},
		methods: {
			onInput(event) {
				this.search	= event.target.value;
				this.open	= true;
			},
			onFocus() {
				this.open = true;
				this.focus = true;
			},
			onBlur() {
				this.search = '';
				this.open = false;
				this.focus = false;
			},
			onSelect(option) {
				this.$emit('input', option.key);
				this.open = false;
			},
			onClear() {
				this.$emit('input', null);
			},
		},
	}
</script>

<style lang="scss" scoped>
	.toolbar-search-view {
		position: relative;
		display: block;
		float: left;
		height: 36px;
		margin-left: 10px;

		& > input {
			border-radius: 20px;
			border: 1px solid #cecece;
			width: 100%;
			height: 100%;
			padding-left: 20px;

			&::placeholder {
				color: #cecece;
			}
		}

		& > .close {
			position: absolute;
			top: 50%;
			right: 10px;
			transform: translateY(-50%);
			cursor: pointer;
			width: 24px;
			height: 24px;
			background-color: #cecece;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;

			& > .icon {
				width: 10px;
				height: 10px;
				fill: white;
				z-index: 99999999;
			}
		}

		& > .options {
			z-index: 99999999;
			position: absolute;
			top: 38px;
			left: 0;
			min-width: 100%;
			background-color: white;
			border: 1px solid #cecece;
			border-top: none;
			border-radius: 20px;
			overflow: hidden;
			box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);

			& > .option {
				padding: 10px;
				border-bottom: 1px solid #cecece;
				cursor: pointer;

				&:hover {
					background-color: #f0f0f0;
				}
			}

			& > .none {
				padding: 10px;
				color: #cecece;
			}
		}
	}
</style>